import { render, staticRenderFns } from "./Registration.vue?vue&type=template&id=660f5e28&"
import script from "./Registration.vue?vue&type=script&lang=js&"
export * from "./Registration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JVolke\\Documents\\plentyDevTool\\38722\\18\\KrauseSohn\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('660f5e28')) {
      api.createRecord('660f5e28', component.options)
    } else {
      api.reload('660f5e28', component.options)
    }
    module.hot.accept("./Registration.vue?vue&type=template&id=660f5e28&", function () {
      api.rerender('660f5e28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/customer/Registration.vue"
export default component.exports